import angular from 'angular';
import { LoadParams } from '../../../shared/models/loadparams.model';
import { IRescisao } from './models/rescisao.model';
import { IConfiguracaoRescisao } from './models/configuracaorescisao';
import { IEstadoWorkflow } from './models/estadoworkflow';

export class MeurhSolicitacoesrescisoesService {
    static $inject = [
        '$http',
        'nsjRouting',
        '$rootScope',
        '$q'
    ];

    public entity: IRescisao;
    public entities: Array<IRescisao> = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: LoadParams;
    public loading_deferred: any = null;
    public filter: any = '';
    public ordenacao: string = 'default';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService & { configuracaoRescisao: IConfiguracaoRescisao },
        public $q: angular.IQService,
    ) {
        this.loadParams = new LoadParams();
    }

    public reload(): Array<IRescisao> {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 1;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter: any = undefined): Array<IRescisao> {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
            Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });
            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_solicitacoesrescisoes_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
                .then((response: any): void => {
                    resolve(response.data);
                })
                .catch((response: any): void => {
                    reject(response);
                });

        });

    }

    public load(): Array<IRescisao> {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any) => {
                    if (data.length > 0) {

                        for (var i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }

                        this.after['created_at'] = this.entities[this.entities.length - 1]['created_at'];
                        this.after['solicitacao'] = this.entities[this.entities.length - 1]['solicitacao'];

                        if (this.ordenacao === 'atualizacao') {
                            this.entities.sort((a: IRescisao, b: IRescisao) => {

                                const dateA = a.lastupdate ? Date.parse(a.lastupdate as string) : 0;
                                const dateB = b.lastupdate ? Date.parse(b.lastupdate as string) : 0;

                                return dateB - dateA;
                            });

                        } else if (this.ordenacao === 'envio') {
                            this.entities.sort((a: IRescisao, b: IRescisao) => {
                                return Date.parse(b.created_at) - Date.parse(a.created_at);
                            });

                        } else if (this.ordenacao === 'rescisao') {
                            this.entities.sort((a: IRescisao, b: IRescisao) => {
                                return Date.parse(b.datarescisao) - Date.parse(a.datarescisao);
                            });
                        }

                    }
                    if (data.length < 20) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }
                    this.loaded = true;

                    this.loadParams.to_load--;
                })
                .catch((error: any): void => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally((): void => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 1;
        this.load();
    }

    find(identifier: string): IRescisao | null {
        for (var i in this.entities) {
            if (this.entities[i]['solicitacao'] === identifier) {
                return this.entities[i];
            }
        }
        return null;
    }

    delete($identifier: any, force: boolean): void {
        if (typeof ($identifier) === 'object') {
            $identifier = $identifier['solicitacao'];
        }
        if ($identifier) {
            if (force || confirm('Tem certeza que deseja deletar?')) {
                this.loading_deferred = this.$q.defer();
                this.$http
                    .delete(this.nsjRouting.generate('meurh_solicitacoesrescisoes_delete', angular.extend(this.constructors, { 'id': $identifier }), true),
                        { timeout: this.loading_deferred.promise })
                    .then((response: any) => {
                        this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_deleted', {
                            entity: this.entity,
                            response: response
                        });
                    })
                    .catch((response: any) => {
                        this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_delete_error', {
                            entity: this.entity,
                            response: response
                        });
                    });
            }
        }
    }

    _save(entity: IRescisao, autosave: boolean): angular.IHttpPromise<any> {
        var method, url;
        if (entity['solicitacao']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_solicitacoesrescisoes_put', { 'id': entity['solicitacao'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_solicitacoesrescisoes_create', angular.extend(this.constructors), true);
        }
        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }
        var data = angular.copy(entity);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        })
            .finally((): void => {
                if (!autosave) {
                    entity['$$__submitting'] = false;
                }
            });
    }

    save(entity: IRescisao, autosave: boolean = false, callback?: Function): void {

        this
            ._save(entity, autosave)
            .then((response: any): void => {
                if (response.data.solicitacao) {
                    entity['solicitacao'] = response.data.solicitacao;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave,
                    callback
                });
            })
            .catch((response: any): void => {
                this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave,
                    callback
                });
            });
    }

    fechar(entity: IRescisao): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;
        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>) => {
            this.$http({
                method: 'post',
                url: this.nsjRouting.generate('meurh_solicitacoesrescisoes_fechar', { 'id': entity.solicitacao }, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                }).finally(() => {
                    entity['$$__submitting'] = false;
                });
        });
    }

    get(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IRescisao>((resolve, reject) => {
            this.$http.get<IRescisao>(
                this.nsjRouting.generate('meurh_solicitacoesrescisoes_get', {
                    id,
                    'vermovimentosfixos': true
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesrescisoes_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => reject(response));
        });
    }

    public getConfiguracaoRescisao(): angular.IHttpPromise<IConfiguracaoRescisao> {
        this.loading_deferred = this.$q.defer();

        return this.$q((
            resolve: angular.IQResolveReject<any>,
            reject: angular.IQResolveReject<any>
        ) => {
            this.$http
                .get(this.nsjRouting.generate('meurh_solicitacoesrescisoes_configuracao', {}, true),
                    { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    this.$rootScope.configuracaoRescisao = response.data;
                    resolve(response);
                })
                .catch((response: any) => {
                    this.$rootScope.configuracaoRescisao = { workflowativado: false };
                    reject(response);
                });
        });
    }

    public getEstadosWorkflow(): angular.IHttpPromise<IEstadoWorkflow[]> {
        this.loading_deferred = this.$q.defer();

        return this.$q((
            resolve: angular.IQResolveReject<any>,
            reject: angular.IQResolveReject<any>
        ) => {
            this.$http
                .get(this.nsjRouting.generate('meurh_solicitacoesrescisoes_estados_workflow', {}, true),
                    { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    resolve(response);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }

    public prorrogarContratoColaboradorTemporario(identifier: string, dataProrrogacaoContrato: string): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((
            resolve: angular.IQResolveReject<any>,
            reject: angular.IQResolveReject<any>
        ) => {
            this.$http
                .post(
                    this.nsjRouting.generate(
                        'meurh_solicitacoes_cancelar',
                        { 'id': identifier },
                        true
                    ),
                    { 'dataprorrogacaocontrato': dataProrrogacaoContrato },
                    { timeout: this.loading_deferred.promise }
                )
                .then((response: any) => {
                    resolve(response);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }

    public getMovimentosRescisaoTrabalhador(identifier: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>) => {
            this.$http
            .get(this.nsjRouting.generate('meurh_movimentospararescisao_index', { 'trabalhador': identifier }, true), { timeout: this.loading_deferred.promise })
                .then((response: any) => {
                    this.$rootScope.$broadcast('meurh_movimentospararescisao_loaded', response.data);
                    resolve(response.data);
                })
                .catch((response: any) => {
                    reject(response);
                });
        });
    }
}
